export default "__VITE_ASSET__DeDkVtL7__"